var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClaims = function SvgClaims(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.499 6.333H11A1.166 1.166 0 1 0 11 4H8.667a.5.5 0 0 0-.5.5v2.667H9.5l-.001-.834zm8.05 1.834H9.823a.167.167 0 0 0-.133.266c.417.546.643 1.214.643 1.9V15a.167.167 0 0 0 .167.167h1.833a.167.167 0 0 1 .167.166v4a.666.666 0 1 0 1.333 0v-4a.167.167 0 0 1 .167-.166h4.852a.16.16 0 0 0 .15-.167V9.667a1.477 1.477 0 0 0-1.453-1.5zM5 15v-4.667a2.167 2.167 0 0 1 4.333 0V15a.166.166 0 0 1-.166.167h-4A.167.167 0 0 1 5 15zm3.069-1.431A.333.333 0 0 0 7.833 13H6.5a.333.333 0 1 0 0 .667h1.333a.333.333 0 0 0 .236-.098z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClaims);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "claims.e3b32ab7407b9d341dec974ced80d1ed.svg";